import RequestAbstract from "./RequestAbstract";

export default class AiCredits extends RequestAbstract {
  get link() {
    return "ai-credits";
  }

  async getBalance() {
    return await this.get(this.link);
  }

  async getPacks() {
    return await this.get(this.link + "/packs");
  }

  async buy(packId) {
    return await this.post(this.link + "/buy", { pack_id: packId });
  }

  async getHistory(page = 1, perPage = 20) {
    return await this.get(`${this.link}/history?page=${page}&per_page=${perPage}`);
  }

  async adminAdjust(userId, amount, reason) {
    return await this.post(`admin/users/${userId}/ai-credits/adjust`, { amount, reason });
  }

  async adminStats(from = null, to = null) {
    let url = "admin/ai-credits/stats";
    const parts = [];
    if (from) parts.push(`from=${from}`);
    if (to) parts.push(`to=${to}`);
    if (parts.length) url += "?" + parts.join("&");
    return await this.get(url);
  }
}
